import { inject, Injectable, signal, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly document = inject(DOCUMENT);
  private darkClassName = 'dark';
  readonly isLightMode = signal(false);

  constructor() {}

  enableDark(): void {
    this.document.documentElement.classList.add(this.darkClassName);
    this.isLightMode.set(false);

    localStorage.setItem('theme', 'dark');
  }

  enableLight(): void {
    this.document.documentElement.classList.remove(this.darkClassName);
    this.isLightMode.set(true);

    localStorage.setItem('theme', 'light');
  }

  toggle(): void {
    if (this.document.documentElement.classList.contains(this.darkClassName)) {
      this.enableLight();
      this.isLightMode.set(true);
    } else {
      this.enableDark();
      this.isLightMode.set(false);
    }
  }

  loadStoredPreference(): void {
    const saved = localStorage.getItem('theme');
    if (saved === 'dark') {
      this.enableDark();
    } else {
      this.enableLight();
    }
  }
}
